import type { html } from 'lit';

import * as occlTemplates from './occl';
import * as tefOneTemplates from './tefOne';

// A function that returns a lit-html html`interpolated string`
export type TemplateFn = (...args: unknown[]) => ReturnType<typeof html> | ReturnType<typeof html>[];
// This index type allows acessing it via a string
type IndexableTemplateFn = {
  [key: string]: TemplateFn;
};

export const occl = occlTemplates as IndexableTemplateFn;
export const tefOne = tefOneTemplates as IndexableTemplateFn;
